/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { action } from 'typesafe-actions';

import {
  ProductActionTypes,
  FindProductProps,
  ResponseProps,
  ProductData,
} from './types';

export function findProductRecharge() {
  return action(ProductActionTypes.RECHARGE);
}


export function findProductRequest() {
  return action(ProductActionTypes.LOAD_REQUEST);
}

export function findProductsSuccess(data: ProductData[]) {
  return action(ProductActionTypes.LOAD_SUCCCES, {
    data,
  });
}

export function findProductsSuccessNextPage(data: ProductData[]) {
  return action(ProductActionTypes.LOAD_SUCCESS_NEXT_PAGE, {
    data,
  });
}

export function findProductSearch(filters: FindProductProps) {
  return action(ProductActionTypes.SEARCH_REQUEST, {
    filters,
  });
}

export function findProductSearchSuccess(data: ProductData[]) {
  return action(ProductActionTypes.SEARCH_REQUEST_SUCCESS, {
    data,
  });
}

export function findProductSuccess(data: ProductData) {
  return action(ProductActionTypes.SEARCH_PRODUCT_SUCCESS, {
    data,
  });
}

export function detailsProduct(data: ProductData) {
  return action(ProductActionTypes.DETAILS, {
    data,
  });
}

export function responseSuccess(data: ResponseProps) {
  return action(ProductActionTypes.RESPONSE_SUCCCES, {
    data,
  });
}

export function findProductFailure() {
  return action(ProductActionTypes.LOAD_FAILURE);
}

export function setProductFilter(filters: FindProductProps, response?: ResponseProps) {
  return action(ProductActionTypes.SET_FILTERS, { filters, response });
}

export function findProduct(filters: FindProductProps) {
  return action(ProductActionTypes.SEARCH_PRODUCT, {
    filters,
  });
}

export function clearProducts() {
  return action(ProductActionTypes.CLEAR_PRODUCTS);
}
